import { Typography } from "@mui/material";

export default function ErrorMessage({ error, visible }) {
  if (!visible || !error) return null;
  return <Typography sx={{ color: "red" }}>{error}</Typography>;
}
